import { render } from "./EnsureService.vue?vue&type=template&id=2980716e&scoped=true&ts=true"
import script from "./EnsureService.vue?vue&type=script&lang=ts"
export * from "./EnsureService.vue?vue&type=script&lang=ts"

import "./EnsureService.vue?vue&type=style&index=0&id=2980716e&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2980716e"]])

export default __exports__